<div
  infiniteScroll
  (scrolled)="onScroll()"
  (scrolledUp)="onScrollUp()"
  [infiniteScrollDistance]="options.downDistance"
  [infiniteScrollUpDistance]="options.upDistance"
  [infiniteScrollThrottle]="options.throttle"
  [scrollWindow]="options.scrollWindow"
  [immediateCheck]="options.immediateCheck"
  [infiniteScrollDisabled]="options.disable"
  [horizontal]="options.horizontal"
  [alwaysCallback]="options.alwaysCallback"
  [fromRoot]="options.fromRoot"
  [infiniteScrollContainer]="options.infiniteScrollContainer"
>
  <ng-content></ng-content>
</div>
